export const ProfilePictureValidationLabels: Record<
  string,
  {
    title: string;
    description: string;
    type: 'warning' | 'error';
    images: string[];
  }
> = {
  not_depict_human: {
    title: 'Does not depict a human',
    description: 'Choose a real photo that clearly shows your face.',
    type: 'error',
    images: [
      'https://ucarecdn.com/5345d4c5-107b-428f-a158-4c6026599d16/-/preview/999x999/',
    ],
  },
  sunglasses: {
    title: 'Wearing sunglasses',
    description:
      'Avoid wearing anything that obscures your face, such as hats or sunglasses.',
    type: 'error',
    images: [
      'https://ucarecdn.com/652b8844-bc88-44dd-8cc7-2d20de635e09/-/preview/999x999/',
    ],
  },
  group_picture: {
    title: 'More than one person shown',
    description:
      'Make sure only you are in the photo to maintain focus on your profile.',
    type: 'error',
    images: [
      'https://ucarecdn.com/320bf798-bc07-43f2-88bf-ee0d2a7efa1b/-/preview/999x999/',
    ],
  },
  props: {
    title: 'Using accessories',
    description:
      'Steer clear of accessories like headphones to maintain a professional appearance.',
    type: 'error',
    images: [
      'https://ucarecdn.com/a5880697-7ccd-431e-8cfa-a66e43b5b1fb/-/preview/999x999/',
    ],
  },
  not_wearing_clothes: {
    title: 'Clothing not detected',
    description: 'Make sure you are wearing clothing in your profile picture.',
    type: 'error',
    images: [
      'https://ucarecdn.com/27324400-ad9e-43ab-b0d1-2530922e298d/-/preview/999x999/',
    ],
  },
  image_not_color: {
    title: 'Black and white image',
    description: 'Consider using a color image to stand out.',
    type: 'warning',
    images: [
      'https://ucarecdn.com/ab4b9b0b-a071-484f-8abd-4cd193535581/-/preview/999x999/',
    ],
  },
  lighting_issues: {
    title: 'Lighting issues',
    description: 'Ensure your face is well-lit and avoid shadows.',
    type: 'warning',
    images: [
      'https://ucarecdn.com/eaa8ed44-4fd1-4be2-a0e2-706c61389256/-/preview/999x999/',
    ],
  },
  distracting_background: {
    title: 'Distracting background',
    description:
      'Ensure the background is neutral or blurred to keep the focus on you.',
    type: 'warning',
    images: [
      'https://ucarecdn.com/84d55d13-473f-424e-8873-9f1bc32af2e7/-/preview/999x999/',
    ],
  },
  selfie: {
    title: 'Selfie image',
    description:
      'Ask someone to take your photo instead of using a selfie for a more professional look.',
    type: 'warning',
    images: [
      'https://ucarecdn.com/3a75b6f7-ff38-44e4-ba0c-6bf8b1caf7b4/-/preview/999x999/',
    ],
  },
  illustration: {
    title: 'Illustration',
    description:
      'Use a real photo instead of an illustration to represent yourself professionally.',
    type: 'warning',
    images: [
      'https://ucarecdn.com/27b4942a-e384-4381-abb3-6d00f7d2128b/-/preview/999x999/',
    ],
  },
  face_far_away: {
    title: 'Zoom in',
    description:
      'Crop the image to ensure your face occupies at least 30% of the frame for better visibility.',
    type: 'warning',
    images: [
      'https://ucarecdn.com/f404d9c2-3a5d-4de4-b3d4-34c347cc74ea/-/preview/999x999/',
    ],
  },
  face_too_close: {
    title: 'Zoom out',
    description:
      'Adjust the photo so your face covers no more than 80% of the frame.',
    type: 'warning',
    images: [
      'https://ucarecdn.com/d8260e7f-04da-4748-96fc-d54e833f8d6e/-/preview/999x999/',
    ],
  },
  angry: {
    title: 'Angry or Intimidating Expression',
    description:
      'Maintain a neutral and friendly expression to appear more approachable.',
    type: 'warning',
    images: [
      'https://ucarecdn.com/05526427-a2c8-46ec-94d6-21a4e5b65e38/-/preview/999x999/',
    ],
  },
  pixelated_blurry: {
    title: 'Pixelated or blurry image',
    description: 'Upload a clear, high-resolution image for better visibility.',
    type: 'warning',
    images: [
      'https://ucarecdn.com/2b31e4a4-03e1-433f-ac91-cc10f0344e61/-/preview/999x999/',
    ],
  },
};
